export const isNullOrUndefined = (value: any): boolean => value === null || value === undefined || value === '';
export const isZeroOrPositiveInt = (value: any): boolean => typeof value === 'number' && value > -1 && value.toString().split('.').length === 1;
export const isProperValue = (value: any): boolean => !isNullOrUndefined(value) && !Number.isNaN(value);
export const isNumericString = (value: string): boolean => /^[-]?(0|([1-9]\d*))([.,]\d+)?$/.exec(value) !== null;

const typeUtil = {
    isNullOrUndefined,
    isZeroOrPositiveInt,
    isProperValue,
    isNumericString,
};

export default typeUtil;
